export default "__VITE_ASSET__UadDO9lw__"